import { Brand, createBranded } from '@deltasierra/type-utilities';

export type ScheduledEmailItemId = Brand<number, 'ScheduledEmailItemId'>;
export const ScheduledEmailItemId = createBranded<ScheduledEmailItemId>();
